import { render, staticRenderFns } from "./OpenIdInitPage.vue?vue&type=template&id=7f3e274e&scoped=true&"
import script from "./OpenIdInitPage.vue?vue&type=script&lang=js&"
export * from "./OpenIdInitPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f3e274e",
  null
  
)

export default component.exports